import { buildQueryParams } from '../functions/buildQueryParams';
import { gridReportsApiSlice } from 'core/services/GridReportsApiSlice';
import { FetchParams, FetchResponse } from '../models';

export const fetchData = async (
  params: FetchParams,
  selectedReport: string,
  activeProjectKey: string,
  dispatch: any,
  isUrlParsed: boolean,
  syncUrlFromParams: (params: FetchParams) => void
): Promise<FetchResponse> => {
  if (isUrlParsed) {
    syncUrlFromParams(params);
  }

  try {
    const queryString = buildQueryParams(params).toString();

    const getDataPromise = dispatch(
      gridReportsApiSlice.endpoints.getGridReport.initiate({
        projectKey: activeProjectKey,
        reportId: selectedReport,
        query: queryString,
      })
    );
    const getSchemaPromise = dispatch(
      gridReportsApiSlice.endpoints.getGridReportSchema.initiate({
        projectKey: activeProjectKey,
        reportId: selectedReport,
      })
    );

    const [dataResult, schemaResult] = await Promise.all([
      getDataPromise,
      getSchemaPromise,
    ]);

    // Throw error if status is rejected for either result
    if (dataResult && (dataResult as any).status === 'rejected') {
      throw new Error('Grid report data fetch failed');
    }
    if (schemaResult && (schemaResult as any).status === 'rejected') {
      throw new Error('Grid report schema fetch failed');
    }

    const dataPayload: any = (dataResult && (dataResult as any).data) || {};
    const schemaPayload: any =
      (schemaResult && (schemaResult as any).data) || {};
    return { ...dataPayload, ...schemaPayload } as FetchResponse;
  } catch (e) {
    throw new Error('Grid report fetch failed');
  }
};
